export const regex = {
  // CNPJ validation regex (XX.XXX.XXX/XXXX-XX or XXXXXXXXXXXXXX)
  cnpj: /^(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14})$/,
  // CPF validation regex (XXX.XXX.XXX-XX or XXXXXXXXXXX)
  cpf: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/,
  // Phone number regex (Brazilian format)
  phone: /^(\+55\s?)?(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})$/,
  // Brazilian postal code regex
  postalCode: /^\d{5}-?\d{3}$/,
  // Exercise set validation patterns
  exercise: {
    repetitions: /^(\d+)(-\d+)?$/,
    time: /^(\d+h)?(\d+min)?(\d+s)?$/i,
  },
} as const;

export const getTaxIdLabel = (value?: string | null): 'CPF' | 'CNPJ' | 'CPF/CNPJ' => {
  const digits = value?.replace(/\D/g, '') ?? '';

  if (digits.length === 11) return 'CPF';
  if (digits.length === 14) return 'CNPJ';

  return 'CPF/CNPJ';
};

export const format = {
  taxId: (value: string, type?: 'cpf' | 'cnpj'): string => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');

    // If it's a CNPJ (14 digits)
    if ((type === 'cnpj' || !type) && digits.length === 14) {
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    // If it's a CPF (11 digits)
    if ((type === 'cpf' || !type) && digits.length === 11) {
      return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }

    return value;
  },

  phoneNumber: (value: string): string => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');

    // Brazilian phone number format
    if (digits.length === 11) {
      return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }

    if (digits.length === 10) {
      return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return value;
  },

  postalCode: (value: string): string => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');

    // Brazilian postal code format
    if (digits.length === 8) {
      return digits.replace(/^(\d{5})(\d{3})$/, '$1-$2');
    }

    return value;
  },

  date: (value: string): string => {
    // remove everything that is not digit
    const digits = value.replace(/\D/g, '');

    if (digits.length <= 2) return digits; // DD
    if (digits.length <= 4) return digits.replace(/^(\d{2})(\d{0,2})$/, '$1/$2'); // DD/MM
    return digits.replace(/^(\d{2})(\d{2})(\d{0,4})$/, '$1/$2/$3'); // DD/MM/AAAA
  },
} as const;

export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 20;

export const SUPPORT_PHONE = '5583993991370';

/** Brazilian states (UF), A→Z by code: every UF select of the portal lists these. */
export const BRAZIL_STATES = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
] as const;
